/**
 * Synchronous re-entry lock for a submit handler that awaits before the
 * mutation is pending. React state cannot close that window: a second click
 * can run before the next render disables the button.
 */
export class SubmissionGuard {
  private locked = false;

  tryBegin(): boolean {
    if (this.locked) return false;
    this.locked = true;
    return true;
  }

  release(): void {
    this.locked = false;
  }

  get isLocked(): boolean {
    return this.locked;
  }
}
